import styled from "styled-components";

export const Container = styled.input`
  ${({ theme }) => theme.inputs.base}
  ${({ large, theme }) => large && theme.inputs.large}
`;
